import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

export default function FixTab() {
    const { useLang, useState, useEffect, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('vanliferoadtrips');
    const [fixH, setFixH] = useState(0);
    const tabs: any = ['uk', 'it', 'es'].includes(locale)
        ? [
              { text: t('fix_tab1'), id: '#vanlife-roadtrips-B', key: 0 },
              { text: t('fix_tab2'), id: '#vanlife-roadtrips-C', key: 1 },
              // { text: t('fix_tab3'), id: '#vanlife-roadtrips-O', key: 2 },
              { text: t('fix_tab4'), id: '#vanlife-roadtrips-P', key: 3 },
              { text: t('fix_tab5'), id: '#vanlife-roadtrips-Q', key: 4 },
              { text: t('fix_tab6'), id: '#vanlife-roadtrips-R', key: 5 },
          ]
        : ['kr', 'eu', 'nl'].includes(locale)
        ? [
              { text: t('fix_tab1'), id: '#vanlife-roadtrips-B', key: 0 },
              { text: t('fix_tab2'), id: '#vanlife-roadtrips-C', key: 1 },
              //   { text: t('fix_tab3'), id: '#vanlife-roadtrips-O', key: 2 },
              { text: t('fix_tab4'), id: '#vanlife-roadtrips-P', key: 3 },
              //   { text: t('fix_tab5'), id: '#vanlife-roadtrips-Q', key: 4 },
              { text: t('fix_tab6'), id: '#vanlife-roadtrips-R', key: 5 },
          ]
        : [
              { text: t('fix_tab1'), id: '#vanlife-roadtrips-B', key: 0 },
              { text: t('fix_tab2'), id: '#vanlife-roadtrips-C', key: 1 },
              { text: t('fix_tab3'), id: '#vanlife-roadtrips-O', key: 2 },
              { text: t('fix_tab4'), id: '#vanlife-roadtrips-P', key: 3 },
              { text: t('fix_tab5'), id: '#vanlife-roadtrips-Q', key: 4 },
              { text: t('fix_tab6'), id: '#vanlife-roadtrips-R', key: 5 },
          ];
    const [activeTab, setActiveTab] = useState(tabs[0]?.id);
    const handleClickTab = (id: string) => {
        setActiveTab(id);
    };

    let originX = 0,
        startX = 0;
    const onTouchStart = (e: any) => {
        originX = parseFloat(e.currentTarget?.style.left) || 0;
        startX = e.targetTouches[0]?.clientX;
    };

    const onTouchMove = (e: any) => {
        const moveX = e.targetTouches[0]?.clientX;
        const endX = originX + moveX - startX;
        if (endX <= 0 && endX >= window.innerWidth - e.currentTarget.offsetWidth) {
            e.currentTarget.style.left = `${endX}px`;
        }
    };

    useEffect(() => {
        const resizeFunc = () => {
            const target = document.querySelector('.vanlife-roadtrips-fix-tab .tabs-box') as HTMLUListElement;
            target.style.transition = 'left .4s ease';
            if (target.offsetWidth > window.innerWidth && Number(tabs?.findIndex((tab: any) => tab?.id === activeTab)) + 1 >= tabs?.length / 2) {
                target.style.left = `${window.innerWidth - target.offsetWidth}px`;
            } else {
                target.style.left = `${0}px`;
            }
        };
        resizeFunc();
        // window.addEventListener('resize', resizeFunc);
        // return () => window.removeEventListener('resize', resizeFunc);
    }, [activeTab]);

    useEffect(() => {
        const scrollFunc = (id: string) => {
            const target = document.querySelector(id) as HTMLDivElement;
            AniContainer.create({
                triggerElement: id,
                triggerHook: 1,
                offset: '50%',
                duration: target?.offsetHeight,
                onEnter: () => setActiveTab(id),
            });
        };
        const ids: string[] = ['uk', 'it', 'es'].includes(locale)
            ? ['#vanlife-roadtrips-B', '#vanlife-roadtrips-C', '#vanlife-roadtrips-P', '#vanlife-roadtrips-Q']
            : ['kr', 'eu', 'nl'].includes(locale)
            ? ['#vanlife-roadtrips-B', '#vanlife-roadtrips-C', '#vanlife-roadtrips-P']
            : ['#vanlife-roadtrips-B', '#vanlife-roadtrips-C', '#vanlife-roadtrips-O', '#vanlife-roadtrips-P', '#vanlife-roadtrips-Q'];

        ids.forEach((id: string) => scrollFunc(id));
        AniContainer.create({
            triggerElement: '#vanlife-roadtrips-R',
            triggerHook: 1,
            offset: '50%',
            onEnter: () => setActiveTab('#vanlife-roadtrips-R'),
        });
        setTimeout(() => {
            let h = 0;
            const elems = ['.announcement-bar', '.activity-bar'];
            elems?.map((cls) => {
                const elem = document.querySelector(cls);
                if (elem) {
                    const computedStyle = window.getComputedStyle(elem);
                    const positionValue = computedStyle.getPropertyValue('position');
                    if (positionValue === 'sticky') {
                        h += elem.offsetHeight;
                    }
                }
            });
            setFixH(h);
        }, 3000);
    }, []);

    return (
        <div className={`vanlife-roadtrips-fix-tab ${css['vanlife-roadtrips-fix-tab']}`} style={{ top: `${fixH}px` }}>
            <div className="tabs-wrapper">
                <ul className="tabs-box" onTouchStart={onTouchStart} onTouchMove={onTouchMove}>
                    {tabs?.map((tab: any) => (
                        <a className={`tab ${activeTab === tab?.id ? 'active' : ''}`} href={tab?.id} key={tab?.id} onClick={() => handleClickTab(tab?.id)}>
                            {tab?.text}
                        </a>
                    ))}
                </ul>
            </div>
        </div>
    );
}
